import { createFileRoute } from '@tanstack/react-router';
import { LandedCostPage } from '../../features/duty';

export const Route = createFileRoute('/portal/duty/')({ component: LandedCostPage });
